import { render, staticRenderFns } from "./Consultar.vue?vue&type=template&id=895c9a8a&scoped=true"
import script from "./Consultar.script.js?vue&type=script&lang=js&external"
export * from "./Consultar.script.js?vue&type=script&lang=js&external"
import style0 from "./Consultar.css?vue&type=style&index=0&id=895c9a8a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895c9a8a",
  null
  
)

export default component.exports